import { css, styled, useTheme } from '@mui/material';

import type { SVGProps } from 'react';

const TableSortDefaultIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <TableSortIconContainer>
      <TableSortIconWrapper>
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path d="M4 12L0 7L8 7L4 12Z" fill={theme.color['icon/disabled']} />
          <path d="M4 0L8 5H0L4 0Z" fill={theme.color['icon/disabled']} />
        </svg>
      </TableSortIconWrapper>
    </TableSortIconContainer>
  );
};

const TableSortAscIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <TableSortIconContainer>
      <TableSortIconWrapper>
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path d="M4 12L0 7L8 7L4 12Z" fill={theme.color['icon/default']} />
          <path d="M4 0L8 5H0L4 0Z" fill={theme.color['icon/disabled']} />
        </svg>
      </TableSortIconWrapper>
    </TableSortIconContainer>
  );
};

const TableSortDescIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <TableSortIconContainer>
      <TableSortIconWrapper>
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path d="M4 12L0 7L8 7L4 12Z" fill={theme.color['icon/disabled']} />
          <path d="M4 0L8 5H0L4 0Z" fill={theme.color['icon/default']} />
        </svg>
      </TableSortIconWrapper>
    </TableSortIconContainer>
  );
};

const TableSortIconContainer = styled('span')(
  () => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    margin-left: 2px;
  `,
);

const TableSortIconWrapper = styled('span')(
  ({ theme }) => css`
    display: inline-block;
    position: relative;
    vertical-align: middle;
    width: 12px;
    height: 16px;
    gap: 0px;

    &:hover {
      border-radius: 4px;
      background-color: ${theme.color['icon/inverse/hover']};
    }
  `,
);

export { TableSortAscIcon, TableSortDefaultIcon, TableSortDescIcon };
